"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.has = exports.get = exports.default = void 0;
var _globals = _interopRequireDefault(require("../globals"));
// eslint-disable-line no-undef
var _default = exports.default = _globals.default.settings;
var has = exports.has = function has(key) {
  return _globals.default.settings[key] !== undefined;
};
var get = exports.get = function get(key, defaultValue) {
  return has(key) ? _globals.default.settings[key] : defaultValue;
};